import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { categories } from "@/mocks/movies";

export default function Navbar() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const isHome = location.pathname === "/";

  return (
    <nav
      className={`w-full z-50 transition-all duration-300 ${
        isHome
          ? "fixed top-0 left-0 bg-transparent"
          : "sticky top-0 bg-white/95 backdrop-blur-sm border-b border-foreground-200/50"
      }`}
      id="navbar"
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-film-line text-lg text-white"></i>
            </div>
            <span className={`font-semibold text-lg ${isHome ? "text-white" : "text-foreground-950"}`}>
              8090电影网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.slice(0, 5).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 text-sm rounded-md whitespace-nowrap cursor-pointer transition-colors ${
                  location.pathname.includes(cat.slug)
                    ? "bg-primary-500/10 text-primary-600 font-medium"
                    : isHome
                      ? "text-white/80 hover:text-white hover:bg-white/10"
                      : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2 text-sm rounded-md whitespace-nowrap cursor-pointer transition-colors ${
                location.pathname === "/about"
                  ? "bg-primary-500/10 text-primary-600 font-medium"
                  : isHome
                    ? "text-white/80 hover:text-white hover:bg-white/10"
                    : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-md cursor-pointer ${
              isHome ? "text-white" : "text-foreground-950"
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-foreground-200/50 shadow-lg">
          <div className="px-4 py-3 flex flex-col gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                onClick={() => setMobileOpen(false)}
                className={`px-3 py-2.5 text-sm rounded-md whitespace-nowrap cursor-pointer transition-colors ${
                  location.pathname.includes(cat.slug)
                    ? "bg-primary-500/10 text-primary-600 font-medium"
                    : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              onClick={() => setMobileOpen(false)}
              className={`px-3 py-2.5 text-sm rounded-md whitespace-nowrap cursor-pointer transition-colors ${
                location.pathname === "/about"
                  ? "bg-primary-500/10 text-primary-600 font-medium"
                  : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}